import { z } from 'zod';
import { OnboardingFormFields } from '@Types/index';
import { Line1Schema } from '@Components/inputs/Line1';
import { AddressStateSchema } from '@Components/inputs/AddressStateDropDown';
import { zipSchema } from '@Components/inputs/ZipAddress/';
import { citySchema } from '@Components/inputs/CityInput';
import type { LiliDropdownItem } from '@lili/lili-frontend-common';

export const RegisteredAddressSchema = z.object({
  ...Line1Schema.shape,
  [OnboardingFormFields.APARTMENT]: z.string().optional(),
  ...citySchema.shape,
  ...zipSchema.shape,
  ...AddressStateSchema.shape,
  [OnboardingFormFields.REGISTERED_ADDRESS_SAME_AS_PRIMARY]: z.boolean().optional(),
});

export interface IRegisteredAddressForm {
  [OnboardingFormFields.LINE1]: string | null;
  [OnboardingFormFields.APARTMENT]: string | null;
  [OnboardingFormFields.CITY]: string | null;
  [OnboardingFormFields.STATE]: LiliDropdownItem | null;
  [OnboardingFormFields.ZIP]: string | null;
  [OnboardingFormFields.REGISTERED_ADDRESS_SAME_AS_PRIMARY]: boolean;
}
